import {
  Box,
  Container,
  Grid,
  Theme,
  Typography,
  useMediaQuery,
} from "@mui/material";

import { ReactComponent as ClinicalSvg } from "assets/images/homepage/clinical.svg";
import { ReactComponent as ComputerSelectTestSvg } from "assets/images/homepage/computer_select_test.svg";
import { ReactComponent as ResearchProductSvg } from "assets/images/homepage/research_product.svg";
import { AMP, CTDNA, DNA, RNA } from "components/acronyms";
import { IDT_REQUEST_CONSULTATION } from "helpers/constants";

import { ServiceOffer } from "./ServiceOffer";
import { ServiceOfferProps } from "./type";

const Offers: ServiceOfferProps[] = [
  {
    title: "Assay Marketplace",
    description: (
      <>
        Browse our catalog of targeted <AMP /> chemistry-based panels, or
        customize your own panel for <RNA />, <DNA />, or <CTDNA /> inputs using
        Assay Marketplace. Assay Marketplace leverages our ever expanding
        database of predesigned, functionally-tested primers to inspire
        confidence in every assay’s performance. Designs are optimized for a
        variety of input types and disease states to help customers select the
        perfect panel for their needs
      </>
    ),
    offerUrl: "/catalog",
    OfferImage: ComputerSelectTestSvg,
  },
  {
    title: "Assay Designer",
    description: (
      <>
        For customers looking to utilize <AMP /> chemistry-based panels for
        novel applications or emerging targets, Assay Designer is an option that
        offers expert custom design services on a fast timeline. This service
        combines expertly reviewed de novo designs with functionally tested
        designs to deliver panels that meet the unique needs of any customer.
      </>
    ),
    offerUrl: IDT_REQUEST_CONSULTATION,
    OfferImage: ResearchProductSvg,
  },
  {
    title: "Designer Pro Premium Customization Service",
    description:
      "For customers seeking an additional layer of support, there’s Designer Pro. Expert scientists work closely with customers through the entire course of development from target selection and curation through design optimization. Panels are iteratively tested in the lab to ensure specified user needs and metrics are met. We also provide full hands-on training and bioinformatic support for a quick and easy transition into your lab. ",
    offerUrl: IDT_REQUEST_CONSULTATION,
    OfferImage: ClinicalSvg,
  },
];

export const ServiceOffers = () => {
  const xs = useMediaQuery((theme: Theme) => theme.breakpoints.only("xs"));

  return (
    <Box
      component="section"
      className="default-bg"
      pt={{ xs: 3, sm: 4, md: 5, lg: 10 }}
      pb={{ xs: 4, sm: 5, md: 7, lg: 12 }}
    >
      <Container>
        <Box
          display="display"
          flexDirection="column"
          maxWidth={{ sm: 428, md: "unset" }}
          margin="auto"
        >
          <Typography component="h2">
            <Box
              component="span"
              display="block"
              textAlign="center"
              mb={{ xs: 2.25, sm: 3, md: 4 }}
              fontSize={xs ? 21 : 32}
              lineHeight={xs ? "31px" : "47px"}
              fontWeight={600}
              letterSpacing={0.5}
            >
              To meet the needs of every lab, we offer three custom services
            </Box>
          </Typography>
          <Grid container>
            <Grid item container spacing={3} component="ul">
              {Offers.map((item: ServiceOfferProps, index: number) => (
                <Grid item xs={12} md={4} key={index} component="li">
                  <ServiceOffer {...item} />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};
